import { BrowserRouter } from 'react-router-dom'

import Routes from './Routes'
import ScrollToTop from './ScrollToTop'

const Router = () => {
  return (
    <BrowserRouter useTransitions={false}>
      <ScrollToTop />
      <Routes />
    </BrowserRouter>
  )
}

export default Router
